import type { AnyAction } from 'redux';
import { take } from 'redux-saga/effects';

/*
 * Like `take` but only takes actions for a single form.
 */
export const takeForm = (actionType: string | string[], formName: string) => {
  return take(
    (action: AnyAction) =>
      (typeof actionType === 'string' ? action.type === actionType : actionType.includes(action.type)) &&
      action.meta?.formName === formName
  );
};
